import user1 from '../../assets/instructorsPhoto/1.jpg';
import user2 from '../../assets/instructorsPhoto/2.jpg';
import user3 from '../../assets/instructorsPhoto/3.jpg';
import user4 from '../../assets/instructorsPhoto/4.jpg';
import user5 from '../../assets/instructorsPhoto/5.jpg';
import user6 from '../../assets/instructorsPhoto/6.jpg';
import user7 from '../../assets/instructorsPhoto/7.jpg';
import user8 from '../../assets/instructorsPhoto/8.jpg';
import user9 from '../../assets/instructorsPhoto/9.jpg';

export const studentsPeople = [
    {
        img: user1,
        name: 'Aziz Said',
        status: 'Inactive',
        last_active: '09 Dec 2017',
        access: '2018-03-13',
        next_payment: '2019-03-28',
        referrals: 4,
        courses: 'MCAT',
        id: '00101'
    },
    {
        img: user2,
        name: 'Raawiya Attia',
        status: 'Blocked',
        last_active: '12 Dec 2017',
        access: '2018-05-05',
        next_payment: '2019-04-28',
        referrals: 10,
        courses: 'MCAT',
        id: '00202'
    },
    {
        img: user3,
        name: 'Jader Wainwrightin',
        status: 'Active',
        last_active: '02 Apr 2017',
        access: '2018-05-05',
        next_payment: '2019-05-28',
        referrals: 5,
        courses: 'MCAT',
        id: '00303'
    },
    {
        img: user4,
        name: 'Alannah Sanger',
        status: 'Active',
        last_active: '15 Jun 2017',
        access: '2018-09-05',
        next_payment: '2019-06-28',
        referrals: 7,
        courses: 'MCAT',
        id: '00404'
    },
    {
        img: user5,
        name: 'Leo Wallace',
        status: 'Inactive',
        last_active: '09 Apr 2017',
        access: '2018-11-27',
        next_payment: '2019-07-28',
        referrals: 5,
        courses: 'MCAT',
        id: '00505'
    },
    {
        img: user6,
        name: 'Hudson Boucaut',
        status: 'Active',
        last_active: '23 Jul 2017',
        access: '2018-02-04',
        next_payment: '2019-08-28',
        referrals: 3,
        courses: 'MCAT',
        id: '00606'
    },
    {
        img: user7,
        name: 'Marcel Gour',
        status: 'Inactive',
        last_active: '28 Jun 2017',
        access: '2018-11-27',
        next_payment: '2019-09-28',
        referrals: 9,
        courses: 'MCAT',
        id: '00707'
    },
    {
        img: user8,
        name: 'Holly Ferguson',
        status: 'Inactive',
        last_active: '02 May 2017',
        access: '2018-11-21',
        next_payment: '2019-10-28',
        referrals: 10,
        courses: 'MCAT',
        id: '00808'
    },
    {
        img: user9,
        name: 'Adam Hudson',
        status: 'Active',
        last_active: '03 Oct 2017',
        access: '2018-05-05',
        next_payment: '2019-11-28',
        referrals: 4,
        courses: 'MCAT',
        id: '00909'
    },
    {
        img: user1,
        name: 'Zachary Summers',
        status: 'Active',
        last_active: '11 Jun 2017',
        access: '2018-05-05',
        next_payment: '2019-12-28',
        referrals: 7,
        courses: 'MCAT',
        id: '01010'
    },
    {
        img: user2,
        name: 'Connor Simmons',
        status: 'Blocked',
        last_active: '01 Sep 2017',
        access: '2018-08-21',
        next_payment: '2019-02-18',
        referrals: 6,
        courses: 'MCAT',
        id: '01111'
    },
    {
        img: user3,
        name: 'Lucy Hassall',
        status: 'Blocked',
        last_active: '25 Sep 2017',
        access: '2018-03-06',
        next_payment: '2019-02-23',
        referrals: 5,
        courses: 'MCAT',
        id: '01212'
    },
    {
        img: user4,
        name: 'Marilyn Bottomley',
        status: 'Active',
        last_active: '03 Aug 2017',
        access: '2018-05-05',
        next_payment: '2019-03-20',
        referrals: 3,
        courses: 'LSAT',
        id: '01313'
    },
    {
        img: user5,
        name: 'Delit Mazuret',
        status: 'Active',
        last_active: '14 Dec 2017',
        access: '2018-01-11',
        next_payment: '2019-04-18',
        referrals: 6,
        courses: 'MCAT',
        id: '01414'
    },
    {
        img: user6,
        name: 'Shahd Khouri',
        status: 'Active',
        last_active: '17 Mar 2017',
        access: '2018-08-21',
        next_payment: '2019-02-11',
        referrals: 3,
        courses: 'MCAT',
        id: '01515'
    },
    {
        img: user7,
        name: 'Isabelle Falstein',
        status: 'Blocked',
        last_active: '08 Oct 2017',
        access: '2018-05-05',
        next_payment: '2019-01-14',
        referrals: 2,
        courses: 'MCAT',
        id: '01616'
    },
    {
        img: user8,
        name: 'Solaine Sorel',
        status: 'Inactive',
        last_active: '08 Nov 2017',
        access: '2018-12-24',
        next_payment: '2019-01-18',
        referrals: 8,
        courses: 'MCAT',
        id: '01717'
    },
    {
        img: user9,
        name: 'Adan Daher',
        status: 'Blocked',
        last_active: '18 Aug 2017',
        access: '2018-03-20',
        next_payment: '2019-05-24',
        referrals: 11,
        courses: 'MCAT',
        id: '01818'
    },
    {
        img: user1,
        name: 'Siham Samaha',
        status: 'Active',
        last_active: '24 Dec 2017',
        access: '2018-03-18',
        next_payment: '2019-05-23',
        referrals: 9,
        courses: 'MCAT',
        id: '01919'
    },
    {
        img: user2,
        name: 'Michael Ponder',
        status: 'Active',
        last_active: '19 Aug 2017',
        access: '2018-12-17',
        next_payment: '2019-05-22',
        referrals: 3,
        courses: 'MCAT',
        id: '02020'
    },
    {
        img: user3,
        name: 'Abdul-Ghafur Wasem',
        status: 'Active',
        last_active: '15 Jun 2017',
        access: '2018-12-25',
        next_payment: '2019-05-21',
        referrals: 6,
        courses: 'MCAT',
        id: '02121'
    },
    {
        img: user4,
        name: 'Lois Copeland',
        status: 'Inactive',
        last_active: '21 Apr 2017',
        access: '2019-01-26',
        next_payment: '2019-06-21',
        referrals: 3,
        courses: 'MCAT',
        id: '02222'
    },
    {
        img: user5,
        name: 'Bethan Khans',
        status: 'Inactive',
        last_active: '02 May 2017',
        access: '2018-02-21',
        next_payment: '2019-06-22',
        referrals: 7,
        courses: 'MCAT',
        id: '02323'
    },
    {
        img: user6,
        name: 'Imogen Curtin',
        status: 'Active',
        last_active: '11 Dec 2017',
        access: '2018-12-13',
        next_payment: '2019-06-27',
        referrals: 3,
        courses: 'MCAT',
        id: '02424'
    },
    {
        img: user7,
        name: 'Jad Allah Sarraf',
        status: 'Inactive',
        last_active: '28 Jun 2017',
        access: '2018-11-27',
        next_payment: '2019-06-14',
        referrals: 9,
        courses: 'LSAT',
        id: '02525'
    },
    {
        img: user8,
        name: 'Lily Laidlaw',
        status: 'Inactive',
        last_active: '02 May 2017',
        access: '2018-11-21',
        next_payment: '2019-06-12',
        referrals: 10,
        courses: 'MCAT',
        id: '02626'
    },
    {
        img: user9,
        name: 'Cammile Aucoin',
        status: 'Active',
        last_active: '03 Oct 2017',
        access: '2018-05-05',
        next_payment: '2019-06-16',
        referrals: 4,
        courses: 'MCAT',
        id: '02727'
    },
    {
        img: user1,
        name: 'Scott Kay',
        status: 'Active',
        last_active: '29 Apr 2017',
        access: '2018-11-27',
        next_payment: '2019-07-18',
        referrals: 6,
        courses: 'MCAT',
        id: '02828'
    },
    {
        img: user2,
        name: 'William Haverfield',
        status: 'Active',
        last_active: '11 Jun 2017',
        access: '2018-05-05',
        next_payment: '2019-07-24',
        referrals: 7,
        courses: 'MCAT',
        id: '02929'
    },
    {
        img: user3,
        name: 'Mark Downie',
        status: 'Blocked',
        last_active: '01 Sep 2017',
        access: '2018-08-21',
        next_payment: '2019-07-18',
        referrals: 6,
        courses: 'MCAT',
        id: '03030'
    },
    {
        img: user4,
        name: 'Bethany Khan',
        status: 'Blocked',
        last_active: '25 Sep 2017',
        access: '2018-03-06',
        next_payment: '2019-07-23',
        referrals: 5,
        courses: 'MCAT',
        id: '03131'
    },
    {
        img: user5,
        name: 'Jade Wainwright',
        status: 'Active',
        last_active: '03 Aug 2017',
        access: '2018-05-05',
        next_payment: '2019-07-23',
        referrals: 3,
        courses: 'MCAT',
        id: '03232'
    },
    {
        img: user6,
        name: 'Habib Bata',
        status: 'Active',
        last_active: '14 Dec 2017',
        access: '2018-01-11',
        next_payment: '2019-07-21',
        referrals: 6,
        courses: 'MCAT',
        id: '03333'
    },
    {
        img: user7,
        name: 'Imogen Landor',
        status: 'Active',
        last_active: '17 Mar 2017',
        access: '2018-08-21',
        next_payment: '2019-07-19',
        referrals: 3,
        courses: 'MCAT',
        id: '03434'
    },
    {
        img: user8,
        name: 'Joan Beauford',
        status: 'Blocked',
        last_active: '08 Oct 2017',
        access: '2018-05-05',
        next_payment: '2019-09-15',
        referrals: 2,
        courses: 'MCAT',
        id: '03535'
    },
    {
        img: user9,
        name: 'Elizabeth Dodge',
        status: 'Inactive',
        last_active: '08 Nov 2017',
        access: '2018-10-24',
        next_payment: '2019-09-16',
        referrals: 8,
        courses: 'MCAT',
        id: '03636'
    },
    {
        img: user1,
        name: 'Angelina Scollen',
        status: 'Blocked',
        last_active: '15 Oct 2017',
        access: '2018-03-14',
        next_payment: '2019-09-17',
        referrals: 1,
        courses: 'MCAT',
        id: '03737'
    },
    {
        img: user2,
        name: 'Delit Mazuret',
        status: 'Blocked',
        last_active: '18 Aug 2017',
        access: '2018-03-20',
        next_payment: '2019-09-18',
        referrals: 11,
        courses: 'MCAT',
        id: '03838'
    },
    {
        img: user3,
        name: 'Loise Copelang',
        status: 'Active',
        last_active: '24 Dec 2017',
        access: '2018-03-18',
        next_payment: '2019-09-20',
        referrals: 9,
        courses: 'MCAT',
        id: '03939'
    },
    {
        img: user4,
        name: 'Aminah Totah',
        status: 'Active',
        last_active: '05 Feb 2018',
        access: '2018-06-21',
        next_payment: '2019-09-21',
        referrals: 5,
        courses: 'MCAT',
        id: '04040'
    },
    {
        img: user5,
        name: 'Aws Kattan',
        status: 'Inactive',
        last_active: '05 Jul 2017',
        access: '2018-08-21',
        next_payment: '2019-10-11',
        referrals: 4,
        courses: 'MCAT',
        id: '04141'
    },
    {
        img: user6,
        name: 'Scarlett Kaur',
        status: 'Active',
        last_active: '19 Aug 2017',
        access: '2018-12-17',
        next_payment: '2019-10-14',
        referrals: 3,
        courses: 'MCAT',
        id: '04242'
    },
    {
        img: user7,
        name: 'Jack Phillips',
        status: 'Active',
        last_active: '15 Jun 2017',
        access: '2018-12-25',
        next_payment: '2019-10-17',
        referrals: 6,
        courses: 'MCAT',
        id: '04343'
    },
    {
        img: user8,
        name: 'Jackson Gadsdon',
        status: 'Inactive',
        last_active: '21 Apr 2017',
        access: '2019-01-26',
        next_payment: '2019-10-19',
        referrals: 3,
        courses: 'MCAT',
        id: '04444'
    },
    {
        img: user9,
        name: 'Comforte Dennis',
        status: 'Inactive',
        last_active: '02 May 2017',
        access: '2018-02-21',
        next_payment: '2019-10-21',
        referrals: 7,
        courses: 'MCAT',
        id: '04545'
    },
];


// WEBPACK FOOTER //
// ./src/data/People/students.js